var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ChangeDetectorRef, ViewRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, of, Subscription } from 'rxjs';
import { catchError, take, tap } from "rxjs/operators";
import { MonitorDataService } from 'app/infrastructure/data/monitor-data.service';
import { AuthenticationService } from 'app/infrastructure/http/authentication/authentication.service';
import { MatDialog } from '@angular/material';
import { FirmwareUpdateDialogComponent } from './firmware-update-dialog/firmware-update-dialog.component';
import { FirmwareUpdateDialogV2Component } from './firmware-update-dialog-v2/firmware-update-dialog-v2.component';
var MonitorsComponent = /** @class */ (function () {
    function MonitorsComponent(monitorsService, route, cdr, auth, dialog) {
        this.cdr = cdr;
        this.auth = auth;
        this.dialog = dialog;
        this.subPages = [];
        this.isLoading = true;
        this.FIRMWARE_DIALOG_KEY = 'firmware_update_2066_dismissed';
        this.FIRMWARE_DIALOG_V2_KEY = 'firmware_update_2066_post_deadline_dismissed';
        this.FIRMWARE_DEADLINE = new Date('2026-06-20');
        this.FIRMWARE_DIALOG_END = new Date('2026-11-01');
        this.firmwareDialogChecked = false;
        this.monitorsService = monitorsService;
        this.subPages = route.snapshot.data.subPages;
    }
    MonitorsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var tapFunction = tap(function () { return setTimeout(function () { _this.isLoading = false; _this.detectChanges(); }, 1); });
        this.subscription = this.monitorsService.getAllForStatusOverview()
            .pipe(tapFunction)
            .subscribe(function (monitors) {
            _this.monitors = monitors;
            _this.detectChanges();
            if (!_this.firmwareDialogChecked) {
                _this.firmwareDialogChecked = true;
                _this.checkFirmwareUpdateDialog(monitors);
            }
        });
    };
    MonitorsComponent.prototype.checkFirmwareUpdateDialog = function (monitors) {
        var _this = this;
        var now = new Date();
        if (now >= this.FIRMWARE_DIALOG_END || monitors.length === 0) {
            return;
        }
        var isPostDeadline = now >= this.FIRMWARE_DEADLINE;
        var dialogKey = isPostDeadline ? this.FIRMWARE_DIALOG_V2_KEY : this.FIRMWARE_DIALOG_KEY;
        if (window.localStorage.getItem(dialogKey) === 'true') {
            return;
        }
        var firmwareChecks = monitors.map(function (m) {
            return _this.monitorsService.getFirmwareUpgradeStatus(m.id).pipe(take(1), catchError(function () { return of(null); }));
        });
        forkJoin(firmwareChecks).subscribe(function (statuses) {
            var hasOutdated = statuses
                .filter(function (s) { return s !== null; })
                .some(function (s) { return s.currentVersion < 2066; });
            if (hasOutdated) {
                var component = isPostDeadline ? FirmwareUpdateDialogV2Component : FirmwareUpdateDialogComponent;
                var dialogRef = _this.dialog.open(component, {
                    maxWidth: '680px',
                    width: '95vw'
                });
                dialogRef.afterClosed().subscribe(function (dontShowAgain) {
                    if (dontShowAgain) {
                        window.localStorage.setItem(dialogKey, 'true');
                    }
                });
            }
        });
    };
    MonitorsComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    MonitorsComponent.prototype.fetchDetails = function (monitor) {
        var details = __assign({}, monitor.details, { info: monitor.monitorType, serialNumber: monitor.serialNumber });
        return details;
    };
    MonitorsComponent.prototype.detectChanges = function () {
        if (this.cdr && !this.cdr.destroyed) {
            this.cdr.detectChanges();
        }
    };
    return MonitorsComponent;
}());
export { MonitorsComponent };
